document.addEventListener('DOMContentLoaded', function () {

  // ----- Self-check chip selector -----
  document.querySelectorAll('.selfcheck').forEach(function (block) {
    var chips = block.querySelectorAll('.selfcheck-chip');
    var result = block.querySelector('.selfcheck-result');
    var selected = new Set();

    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chip.classList.toggle('is-active');
        var key = chip.getAttribute('data-key');
        if (selected.has(key)) {
          selected.delete(key);
        } else {
          selected.add(key);
        }
        if (result) {
          if (selected.size > 0) {
            result.classList.add('is-visible');
          } else {
            result.classList.remove('is-visible');
          }
        }
      });
    });
  });

  // ----- Quantity steppers -----
  document.querySelectorAll('[data-qty-form]').forEach(function (form) {
    var input = form.querySelector('.qty-input');
    var minus = form.querySelector('[data-qty-minus]');
    var plus = form.querySelector('[data-qty-plus]');
    if (minus) {
      minus.addEventListener('click', function () {
        var v = Math.max(1, parseInt(input.value || '1', 10) - 1);
        input.value = v;
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        var v = parseInt(input.value || '1', 10) + 1;
        input.value = v;
      });
    }
  });

  // ----- Mobile nav toggle -----
  var navToggle = document.querySelector('[data-nav-toggle]');
  var nav = document.querySelector('.site-nav');
  if (navToggle && nav) {
    navToggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
    });
  }
});
